export default {
  pickerOptions: {
    shortcuts: [{
      text: '最近10分钟',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 1000 * 60 * 10);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近1小时',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 1000 * 60 * 60);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近3小时',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 1000 * 60 * 60 * 3);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近24小时',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 1000 * 60 * 60 * 24);
        picker.$emit('pick', [start, end]);
      }
    }]
  },
}
